export default __webpack_public_path__ + "static/media/mentora-logo.f21d852e.png";